import http from "../utility/http";

const BASE = "/v1/user/access-tokens";

const List = async () => http.get(BASE);

const Create = async (name) => http.post(BASE, { name });

const Revoke = async (id) => http.delete(`${BASE}/${id}`);

const userAccessTokenService = {
  List,
  Create,
  Revoke,
};

export default userAccessTokenService;
